export const DOMAIN_WORKSPACE_MISMATCH_EVENT_NAME = 'zoofizjo:domain-workspace-mismatch';

let boundTenantId = '';

export function bindHostWorkspaceTenant(tenantId: string): void {
  boundTenantId = tenantId;
}

export function readBoundHostWorkspaceTenantId(): string {
  return boundTenantId;
}

export function resolveWorkspaceHeaderForHost(storedSelection: string): string {
  if (boundTenantId.length === 0) {
    return storedSelection;
  }
  return storedSelection.endsWith(boundTenantId) ? storedSelection : '';
}

export function buildPlatformUrl(platformUrl: string, path: string): string {
  return platformUrl.replace(/\/+$/, '') + path;
}
